"use strict";

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Based on: https://github.com/steemit/condenser/raw/master/src/shared/HtmlReady.js
 */
// tslint:disable max-classes-per-file

var typescript_chained_error_1 = require("typescript-chained-error");

var xmldom = require("xmldom");

var Log_1 = require("../../../Log");

var LinkSanitizer_1 = require("../../../security/LinkSanitizer");

var DefaultRendererLocalization_1 = require("../DefaultRendererLocalization");

var AssetEmbedderOptions_1 = require("./AssetEmbedderOptions");

var AccountNameValidator_1 = require("./utils/AccountNameValidator");

var Links_1 = require("./utils/Links");

var VideoEmbedders_1 = require("./videoembedders/VideoEmbedders");

var YoutubeEmbedder_1 = require("./videoembedders/YoutubeEmbedder");

var HtmlDOMParser =
/*#__PURE__*/
function () {
  function HtmlDOMParser(options) {
    var localization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultRendererLocalization_1.DefaultRendererLocalization.DEFAULT;

    _classCallCheck(this, HtmlDOMParser);

    this.domParser = new xmldom.DOMParser({
      errorHandler: {
        warning: function warning() {
          /* */
        },
        error: function error() {
          /* */
        }
      }
    });
    this.xmlSerializer = new xmldom.XMLSerializer();
    this.mutate = true;
    this.parsedDocument = undefined;
    AssetEmbedderOptions_1.AssetEmbedderOptions.validate(options);
    this.options = options;
    this.localization = localization;
    this.linkSanitizer = new LinkSanitizer_1.LinkSanitizer({
      baseUrl: this.options.baseUrl
    });
    this.state = {
      hashtags: new Set(),
      usertags: new Set(),
      htmltags: new Set(),
      images: new Set(),
      links: new Set()
    };
  }

  _createClass(HtmlDOMParser, [{
    key: "setMutateEnabled",
    value: function setMutateEnabled(mutate) {
      this.mutate = mutate;
      return this;
    }
  }, {
    key: "parse",
    value: function parse(html) {
      try {
        var doc = this.domParser.parseFromString(html, "text/html");
        this.traverseDOMNode(doc);
        if (this.mutate) this.postprocessDOM(doc);
        this.parsedDocument = doc;
      } catch (error) {
        throw new HtmlDOMParser.HtmlDOMParserError("Parsing error", error);
      }

      return this;
    }
  }, {
    key: "getState",
    value: function getState() {
      if (!this.parsedDocument) throw new HtmlDOMParser.HtmlDOMParserError("Html has not been parsed yet");
      return this.state;
    }
  }, {
    key: "getParsedDocument",
    value: function getParsedDocument() {
      if (!this.parsedDocument) throw new HtmlDOMParser.HtmlDOMParserError("Html has not been parsed yet");
      return this.parsedDocument;
    }
  }, {
    key: "getParsedDocumentAsString",
    value: function getParsedDocumentAsString() {
      return this.xmlSerializer.serializeToString(this.getParsedDocument());
    }
  }, {
    key: "traverseDOMNode",
    value: function traverseDOMNode(node) {
      var _this = this;

      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!node || !node.childNodes) {
        return;
      }

      Array.from(node.childNodes).forEach(function (child) {
        var tag = child.tagName ? child.tagName.toLowerCase() : null;

        if (tag) {
          _this.state.htmltags.add(tag);
        }

        if (tag === "img") {
          _this.processImgTag(child);
        } else if (tag === "iframe") {
          _this.processIframeTag(child);
        } else if (tag === "a") {
          _this.processLinkTag(child);
        } else if (child.nodeName === "#text") {
          _this.processTextNode(child);
        }

        _this.traverseDOMNode(child, depth + 1);
      });
    }
  }, {
    key: "processLinkTag",
    value: function processLinkTag(child) {
      var url = child.getAttribute("href");

      if (url) {
        this.state.links.add(url);

        if (this.mutate) {
          // Unlink potential phishing attempts
          var urlTitle = child.textContent + "";
          var sanitizedLink = this.linkSanitizer.sanitizeLink(url, urlTitle);

          if (sanitizedLink === false) {
            var phishyDiv = child.ownerDocument.createElement("div");
            phishyDiv.textContent = "".concat(child.textContent, " / ").concat(url);
            phishyDiv.setAttribute("title", this.localization.phishingWarning);
            phishyDiv.setAttribute("class", "phishy");
            child.parentNode.replaceChild(phishyDiv, child);
          } else {
            child.setAttribute("href", sanitizedLink);
          }
        }
      }
    } // wrap iframes in div.videoWrapper to control size/aspect ratio

  }, {
    key: "processIframeTag",
    value: function processIframeTag(child) {
      var url = child.getAttribute("src");
      if (url) this.reportIframeLink(url);

      if (!this.mutate) {
        return;
      }

      var tag = child.parentNode.tagName ? child.parentNode.tagName.toLowerCase() : child.parentNode.tagName;

      if (tag === "div" && child.parentNode.getAttribute("class") === "videoWrapper") {
        return;
      }

      var html = this.xmlSerializer.serializeToString(child);
      child.parentNode.replaceChild(this.domParser.parseFromString("<div class=\"videoWrapper\">".concat(html, "</div>")), child);
    }
  }, {
    key: "reportIframeLink",
    value: function reportIframeLink(url) {
      var yt = YoutubeEmbedder_1.YoutubeEmbedder.getYoutubeMetadataFromLink(url);

      if (yt) {
        this.state.links.add(yt.url);
        this.state.images.add("https://img.youtube.com/vi/" + yt.id + "/0.jpg");
      }
    }
  }, {
    key: "processImgTag",
    value: function processImgTag(child) {
      var url = child.getAttribute("src");

      if (url) {
        this.state.images.add(url);

        if (this.mutate) {
          var url2 = this.normalizeUrl(url);

          if (/^\/\//.test(url2)) {
            // Change relative protocol imgs to https
            url2 = "https:" + url2;
          }

          if (url2 !== url) {
            child.setAttribute("src", url2);
          }
        }
      }
    }
  }, {
    key: "processTextNode",
    value: function processTextNode(child) {
      var _this2 = this;

      try {
        var tag = child.parentNode.tagName ? child.parentNode.tagName.toLowerCase() : child.parentNode.tagName;

        if (tag === "code") {
          return;
        }

        if (tag === "a") {
          return;
        }

        if (!child.data) {
          return;
        }

        var embedResp = VideoEmbedders_1.VideoEmbedders.processTextNodeAndInsertEmbeds(child);
        embedResp.images.forEach(function (img) {
          return _this2.state.images.add(img);
        });
        embedResp.links.forEach(function (link) {
          return _this2.state.links.add(link);
        });
        var data = this.xmlSerializer.serializeToString(child);
        var content = this.linkify(data);

        if (this.mutate && content !== data) {
          var newChild = this.domParser.parseFromString("<span>".concat(content, "</span>"));
          child.parentNode.replaceChild(newChild, child);
          return newChild;
        }
      } catch (error) {
        Log_1.Log.log().error(error);
      }
    }
  }, {
    key: "linkify",
    value: function linkify(content) {
      var _this3 = this;

      // plaintext links
      content = content.replace(Links_1.any("gi"), function (ln) {
        if (Links_1.default.image.test(ln)) {
          _this3.state.images.add(ln);

          return "<img src=\"".concat(_this3.normalizeUrl(ln), "\" />");
        } // do not linkify .exe or .zip urls


        if (/\.(zip|exe)$/i.test(ln)) {
          return ln;
        } // do not linkify phishy links


        var sanitizedLink = _this3.linkSanitizer.sanitizeLink(ln, ln);

        if (sanitizedLink === false) {
          return "<div title='".concat(_this3.localization.phishingWarning, "' class='phishy'>").concat(ln, "</div>");
        }

        _this3.state.links.add(sanitizedLink);

        var out = "<a href=\"".concat(_this3.normalizeUrl(ln), "\">").concat(sanitizedLink, "</a>");
        return out;
      }); // hashtag

      content = content.replace(/(^|\s)(#[-a-z\d]+)/gi, function (tag) {
        if (/#[\d]+$/.test(tag)) {
          return tag;
        } // Don't allow numbers to be tags


        var space = /^\s/.test(tag) ? tag[0] : "";
        var tag2 = tag.trim().substring(1);
        var tagLower = tag2.toLowerCase();

        _this3.state.hashtags.add(tagLower);

        if (!_this3.mutate) {
          return tag;
        }

        var tagUrl = _this3.options.hashtagUrlFn(tagLower);

        return space + "<a href=\"".concat(tagUrl, "\">").concat(tag.trim(), "</a>");
      }); // usertag (mention)
      // Cribbed from https://github.com/twitter/twitter-text/blob/v1.14.7/js/twitter-text.js#L90

      content = content.replace(/(^|[^a-zA-Z0-9_!#$%&*@＠\/]|(^|[^a-zA-Z0-9_+~.-\/#]))[@＠]([a-z][-\.a-z\d]+[a-z\d])/gi, function (match, preceeding1, preceeding2, user) {
        var userLower = user.toLowerCase();
        var valid = AccountNameValidator_1.AccountNameValidator.validateAccountName(userLower, _this3.localization) == null;

        if (valid && _this3.state.usertags) {
          _this3.state.usertags.add(userLower);
        } // include the preceeding matches if they exist


        var preceedings = (preceeding1 || "") + (preceeding2 || "");

        if (!_this3.mutate) {
          return "".concat(preceedings).concat(user);
        }

        var userTagUrl = _this3.options.usertagUrlFn(userLower);

        return valid ? "".concat(preceedings, "<a href=\"").concat(userTagUrl, "\">@").concat(user, "</a>") : "".concat(preceedings, "@").concat(user);
      });
      return content;
    }
  }, {
    key: "postprocessDOM",
    value: function postprocessDOM(doc) {
      this.hideImagesIfNeeded(doc);
      this.proxifyImagesIfNeeded(doc);
    }
  }, {
    key: "hideImagesIfNeeded",
    value: function hideImagesIfNeeded(doc) {
      if (this.mutate && this.options.hideImages) {
        var _arr = Array.from(doc.getElementsByTagName("img"));

        for (var _i = 0; _i < _arr.length; _i++) {
          var image = _arr[_i];
          var pre = doc.createElement("pre");
          pre.setAttribute("class", "image-url-only");
          pre.appendChild(doc.createTextNode(image.getAttribute("src") || ""));

          if (image.parentNode) {
            image.parentNode.replaceChild(pre, image);
          }
        }
      }
    }
  }, {
    key: "proxifyImagesIfNeeded",
    value: function proxifyImagesIfNeeded(doc) {
      if (this.mutate && !this.options.hideImages) {
        this.proxifyImages(doc);
      }
    } // For all img elements with non-local URLs, prepend the proxy URL (e.g. `https://img0.steemit.com/0x0/`)

  }, {
    key: "proxifyImages",
    value: function proxifyImages(doc) {
      var _this4 = this;

      if (!doc) {
        return;
      }

      Array.from(doc.getElementsByTagName("img")).forEach(function (node) {
        var url = node.getAttribute("src") || "";

        if (!Links_1.default.local.test(url)) {
          node.setAttribute("src", _this4.options.imageProxyFn(url));
        }
      });
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(url) {
      if (this.options.ipfsPrefix) {
        // Convert //ipfs/xxx  or /ipfs/xxx  into  https://steemit.com/ipfs/xxxxx
        if (/^\/?\/ipfs\//.test(url)) {
          var slash = url.charAt(1) === "/" ? 1 : 0;
          url = url.substring(slash + "/ipfs/".length); // start with only 1 /

          return this.options.ipfsPrefix + "/" + url;
        }
      }

      return url;
    }
  }]);

  return HtmlDOMParser;
}();

exports.HtmlDOMParser = HtmlDOMParser;

(function (HtmlDOMParser) {
  var HtmlDOMParserError =
  /*#__PURE__*/
  function (_typescript_chained_e) {
    _inherits(HtmlDOMParserError, _typescript_chained_e);

    function HtmlDOMParserError(message, cause) {
      _classCallCheck(this, HtmlDOMParserError);

      return _possibleConstructorReturn(this, _getPrototypeOf(HtmlDOMParserError).call(this, message, cause));
    }

    return HtmlDOMParserError;
  }(typescript_chained_error_1.default);

  HtmlDOMParser.HtmlDOMParserError = HtmlDOMParserError;
})(HtmlDOMParser = exports.HtmlDOMParser || (exports.HtmlDOMParser = {}));
/*

*/

/****************
 * Legacy docs of HtmlReady:
 */

/**
 * Functions performed by HTMLReady
 *
 * State reporting
 *  - hashtags: collect all #tags in content
 *  - usertags: collect all @mentions in content
 *  - htmltags: collect all html <tags> used (for validation)
 *  - images: collect all image URLs in content
 *  - links: collect all href URLs in content
 *
 * Mutations
 *  - link()
 *    - ensure all <a> href's begin with a protocol. prepend https:// otherwise.
 *  - iframe()
 *    - wrap all <iframe>s in <div class="videoWrapper"> for responsive sizing
 *  - img()
 *    - convert any <img> src IPFS prefixes to standard URL
 *    - change relative protocol to https://
 *  - linkifyNode()
 *    - scans text content to be turned into rich content
 *    - embedYouTubeNode()
 *      - identify plain youtube URLs and prep them for "rich embed"
 *    - linkify()
 *      - scan text for:
 *        - #tags, convert to <a> links
 *        - @mentions, convert to <a> links
 *        - naked URLs
 *          - if img URL, normalize URL and convert to <img> tag
 *          - otherwise, normalize URL and convert to <a> link
 *  - proxifyImages()
 *    - prepend proxy URL to any non-local <img> src's
 *
 * We could implement 2 levels of HTML mutation for maximum reuse:
 *  1. Normalization of HTML - non-proprietary, pre-rendering cleanup/normalization
 *    - (state reporting done at this level)
 *    - normalize URL protocols
 *    - convert naked URLs to images/links
 *    - convert embeddable URLs to <iframe>s
 *    - basic sanitization?
 *  2. Steemit.com Rendering - add in proprietary Steemit.com functions/links
 *    - convert <iframe>s to custom objects
 *    - linkify #tags and @mentions
 *    - proxify images
 *
 * TODO:
 *  - change ipfsPrefix(url) to normalizeUrl(url)
 *    - rewrite IPFS prefixes to valid URLs
 *    - schema normalization
 *    - gracefully handle protocols like ftp, mailto
 */

/** Split the HTML on top-level elements. This allows react to compare separately, preventing excessive re-rendering.
 * Used in MarkdownViewer.jsx
 */
// export function sectionHtml (html) {
//   const doc = this.domParser.parseFromString(html, 'text/html')
//   const sections = Array(...doc.childNodes).map(child => this.xmlSerializer.serializeToString(child))
//   return sections
// }

/* Embed videos, link mentions and hashtags, etc...
    If hideImages and mutate is set to true all images will be replaced
    by <pre> elements containing just the image url.
*/